
import chatDelete from '../../components/chat/chatDelete.vue';
import liveFooter from '../../components/chat/liveFooter.vue';
import imageModal from '../../components/chat/liveImageModal.vue';
import Loading from '../../components/chat/loding.vue';
import MessagePopup from '../../components/chat/messagePopup.vue';
import LiveUserPopup from '../../components/chat/liveUserPopup.vue';
import SharePopup from '../../components/chat/sharePopup.vue';
import KakaoHelper from '../../utils/KakaoHelper';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
// http://localhost:3000/chat/live?groupId=3524
export default {
  layout: 'live',
  auth: false,
  components: {
    liveFooter,
    imageModal,
    chatDelete,
    Loading,
    MessagePopup,
    SharePopup,
    LiveUserPopup,
  },
  head() {
    return {
      title: '자유마을',
      meta: [
        // 기본 메타 태그
        {
          hid: 'description',
          name: 'description',
          content: '이제 자유마을에서 실시간 방송을??',
        },
        // Open Graph 메타 태그
        {
          hid: 'og:title',
          property: 'og:title',
          content: '자유마을TV 24시간 실시간 채팅',
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: '이제 자유마을에서 실시간 방송을??',
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `https://api.jayuvillage.com/images/3524.png`,
        },
        // 추가적으로 필요한 OG 태그를 여기에 추가할 수 있습니다.
      ],
    };
  },
  data() {
    return {
      token: '',
      chats: [],
      isDropdownOpen: false, // 채팅 드랍버튼
      search: '',
      isFocused: false,
      count: 0,
      searchData: '',
      imageShow: false,
      imageUrl: null, // 이미지 클릭시 url값
      groupId: '',
      modalShow: false,
      vh: 0, // 높이
      loading: false,
      selectedMessageId: null,
      visible: false, // 메시지 차단 삭제 팝업
      liveVisible: false, // 라이브 유저 팝업
      userId: null,
      blackList: [],
      botInterval: null, // 봇메시지 5분마다 실행
      botApiInterval: null, // 봇 api 10분마다 불러오기
      botMessages: null,
      shareVisible: false, // 공유 팝업
      youtubePlayer: 'null',
      youtubeImg: null,
      noticeTitle: null, // 공지 제목
      noticeShow: true, // 공지show
      noticeInterval: null, // 공지 반복api
      userCount: null,
      checkVisible: false,
      checkData: {
        district: 0,
        election: 0,
        state: 0,
      }, // 출석통계
      districtManager: 0,
      electionManager: 0,
      stateManager: 0,
    };
  },
  methods: {
    onImageError(event) {
      // 기본 프로필 이미지로 변경
      event.target.src = require('@/assets/images/profile.svg');
    },

    //메시지 보냈을때 값
    messageSubmit(value) {
      this.chats.push(value[0].group);
    },
    // 이미지 클륵시 모달 오픈
    modalOpen(url) {
      this.imageShow = true;
      this.imageUrl = url;
    },
    // 이미지 모달 끄기
    closeModal(value) {
      this.imageShow = value;
    },

    // 채팅방 나가기 모달 취소
    cancelModal(value) {
      this.modalShow = value;
    },
    // 드랍버튼
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      this.$nextTick(() => {
        this.$refs.dropdown.focus();
      });
    },
    // 드랍버튼 닫기
    closeDropdown() {
      this.isDropdownOpen = false;
    },

    // 서치바 클릭
    searchBtn() {
      this.$store.commit('setEmoticonOption', false);
      if (this.searchOpen == false) {
        this.$store.commit('setOption', false);
      }
      this.$store.commit('setSearchOption', !this.$store.state.chatSearch);
    },
    changeSearch(e) {
      this.search = e.target.value;
    },

    searchFocus(event) {
      if (event.key === 'Enter') {
        // let foundItem = '';
        // const foundItem = this.chats.find(item => item.message === this.search);
        let foundItem = this.chats.filter(
          (item) => item.message && item.message.includes(this.search)
        );
        if (this.search == '') {
          alert('대화내용을 입력해주세요.');
          return;
        }
        if (foundItem != '') {
          //찾는 값이 존재할때
          if (this.search != this.searchData) {
            this.count = 0;

            try {
              let searchRef = `searchRef${foundItem[this.count].id}`;
              let messageDisplay = this.$refs[searchRef][0];
              this.$nextTick(() => {
                messageDisplay.scrollIntoView('center');
              });
            } catch (e) {
              console.log(e);
            } finally {
              this.searchData = this.search; //카운트 늘린다.
            }
            return;
          } else if (this.search == this.searchData) {
            if (this.count >= foundItem.length) {
              alert('대화내용이 끝입니다.');
              this.count = 0;
              return;
            } else {
              this.count++;
              try {
                let searchRef = `searchRef${foundItem[this.count].id}`;
                let messageDisplay = this.$refs[searchRef][0];
                this.$nextTick(() => {
                  messageDisplay.scrollIntoView('center');
                });
              } catch (e) {
                console.log(e);
              } finally {
                this.search = this.searchData;
              }
            }
          }
        } else {
          alert('해당 검색 내용이 없습니다.');
          return;
        }
      }
    },

    isDifferentDate(index) {
      if (index === 0) {
        return true; // 첫 번째 메시지는 항상 다른 날짜로 분류
      }
      const prevMessage = this.chats[index - 1];
      const currMessage = this.chats[index];
      return prevMessage.created_at !== currMessage.created_at;
    },

    showPopup(messageId, userId) {
      if (this.$auth.user) {
        (this.visible = true), (this.selectedMessageId = messageId);
        this.userId = userId;
      }
    },

    deleteMessage(data) {
      this.chats = this.chats.filter((message) => message.id !== data.group.id);
    },
    async blockUser(userId) {
      this.blackList.push(userId);
      const list = {
        room_id: this.groupId,
        block_id: userId,
        user_id: this.$auth.user?.id,
      };
      const response = await this.$axios.post('/api/black-lists', list);
    },
    close(data) {
      this.visible = data;
    },
    liveClose(data) {
      this.liveVisible = data;
    },
    // 채팅방 블랙리스트 가져오기
    async blackListApi() {
      const response = await this.$axios.get('/api/black-lists', {
        params: {
          room_id: this.groupId,
          user_id: this.$auth.user?.id,
        },
      });
      if (response.data.result == true) {
        const myBlack = response.data.myBlack.blocks;
        const roomBlack = response.data.roomBlack.blocks;
        const merged = myBlack.concat(roomBlack);
        this.blackList = merged.filter(
          (item, pos) => merged.indexOf(item) === pos
        );
        this.blackList = this.blackList.map((item) => parseInt(item, 10));
      }
    },
    // 채팅봇 대화내용 불러오기
    async botApi() {
      const response = await this.$axios.get('/api/bots', {
        params: {
          room_id: this.groupId,
        },
      });
      this.botMessages = response.data.data;
    },

    // 3분마다 봇메시지 추가
    addBotMessage() {
      const message =
        this.botMessages[Math.floor(Math.random() * this.botMessages.length)];
      message.profile = require('@/assets/images/chat_bot.svg');
      this.chats.push(message);
    },

    // 공유팝업
    sharePopup() {
      // this.shareVisible = true;
      if (navigator.share) {
        navigator
          .share({
            title: '자유마을TV',
            url: window.location.href,
          })
          .then(() => {
            console.log('공유 성공!');
          })
          .catch((error) => {
            console.error('공유 실패:', error);
          });
      } else {
        this.kakaoHelper.initShareLive(this.youtubeImg);
      }
    },
    shareClose(data) {
      this.shareVisible = data;
    },
    // 썸네일 불러오기
    async thumbnailApi() {
      const response = await this.$axios.get(`/api/rooms/${this.groupId}`);
      this.youtubePlayer = response.data.data.url;
      this.youtubeImg = response.data.data.thumbnail;
    },

    // 공지 불러오기
    async noticeApi() {
      const response = await this.$axios.get(`/api/manager-notice`, {
        params: {
          room_id: this.groupId,
        },
      });
      if (response.data.data != null) {
        if (this.noticeTitle != response.data.data[0].message) {
          this.noticeTitle = response.data.data[0].message;
          this.noticeShow = true;
        }
      }
    },

    // 시청자 카운트 ++
    async countUp() {
      const data = {
        room_id: this.groupId,
      };
      const response = await this.$axios.post(`/api/rooms/count-up`, { data });
      this.userCount = response.data.count;
    },

    async countDown() {
      const data = {
        room_id: this.groupId,
      };
      await this.$axios.post(`/api/rooms/count-down`, {
        data,
      });
    },

    countSubmit(data) {
      this.userCount = data.group.visitor_count;
    },

    // 출석하기
    async userCheck() {
      const response = await this.$axios.post(
        `/api/presence-store/${this.$auth.user?.id}`
      );

      if (response.data.result == true) {
        const data = {
          username: this.$auth.user?.name,
          message: '',
          user_id: this.$auth.user?.id,
          name: this.$auth.user?.name,
          image: '',
          room_id: this.$route.query.groupId,
          alerts: 1,
          message_position_id: this.messagePosition(this.$auth.user?.position),
        };
        await this.$axios.post('/api/messages', data);
        await this.checkApi();
      }
    },

    connect() {
      if (!window.Pusher) window.Pusher = Pusher;
      if (!this.echo) {
        this.echo = new Echo({
          broadcaster: 'pusher',
          key: '668bac10cc6db3a1338c',
          cluster: 'ap3',
          authEndpoint: '/api/broadcasting/auth',
        });
      }
      this.echo
        .channel(`chats` + this.$route.query.groupId)
        .listen('JoinMessage', (e) => {
          if (e.group.message_type == 0) {
            // this.onChatSent(e);
          } else if (e.group.message_type == 1) {
            // this.deleteChat(e);
          }
        });
      this.echo.channel('page-views').listen('PageViewed', (e) => {
        this.$emit('countSubmit', e);
      });
    },
    disconnect() {
      this.echo.leaveChannel(`chats` + this.$route.query.groupId);
      this.echo.leaveChannel(`page-views`);
    },
    // 뒷자리 숫자 확인
    getLastDigit(num) {
      return Math.abs(num % 10);
    },

    async checkApi() {
      try {
        const response = await this.$axios.get(`/api/message-stats/0`);
        this.checkData.district = response.data.data[2].total;
        this.checkData.election = response.data.data[1].total;
        this.checkData.state = response.data.data[0].total;
        this.stateManager = response.data.stateManager;
        this.districtManager = response.data.districtManager;
        this.electionManager = response.data.electionManager;
      } catch (e) {
        console.log(e);
      }
    },
    messagePosition(id) {
      if (id == '조직국장' || id == '총괄팀장') {
        return 1;
      } else if (id == '실행위원장') {
        return 2;
      } else if (id == '동대표') {
        return 3;
      } else if (id == '동임원') {
        return 4;
      } else {
        return 5;
      }
    },
  },
  computed: {
    chatList() {
      this.chats = this.chats.filter(
        (message) => !this.blackList.includes(message.user_id)
      );
      return this.chats;
    },
    searchOpen() {
      return this.$store.state.chatSearch;
    },
  },
  watch: {
    chats() {
      this.$nextTick(() => {
        let messageDisplay = this.$refs.chatSection;
        messageDisplay.scrollTo({
          top: messageDisplay.scrollHeight,
          behavior: 'instant',
        });
      });
    },
  },

  mounted() {
    if (this.$store.state.isFlutter && window.hideBtn) {
      window.hideBtn.postMessage(`hide:${this.$route.path}`);
    }
    // 소켓 연결
    if (this.echo) this.disconnect();
    this.connect();
    // 출석체크
    if (this.$auth.user) {
      this.userCheck();
    }
    this.checkApi();

    this.countUp();
    window.addEventListener('beforeunload', this.countDown);
    // 주소 카카오
    if (process.client) {
      this.url = window.location.href;
    }
    this.kakaoHelper = new KakaoHelper(Kakao);
    this.vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${this.vh}px`);
    window.addEventListener('resize', () => {
      this.vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${this.vh}px`);
    });

    this.$nextTick(() => {
      this.$refs.chatSection.click(
        this.$nextTick(() => {
          let messageDisplay = this.$refs.chatTop;
          messageDisplay.scrollTo({ top: 0, behavior: 'instant' });
        })
      );
    });
    //  3분마다 메시지 추가
    this.botInterval = setInterval(this.addBotMessage, 300000);
    this.botApiInterval = setInterval(this.botApi, 600000);
    this.noticeInterval = setInterval(this.noticeApi, 600000);
    // 외부 클릭시 닫기
    // document.addEventListener('click', this.documentClick)
  },

  beforeDestroy() {
    this.countDown();
    window.removeEventListener('beforeunload', this.countDown);
    // 외부 클릭시 닫기 삭제
    // document.removeEventListener('click', this.documentClick)
    if (this.botInterval) {
      clearInterval(this.botInterval);
    }
    if (this.botApiInterval) {
      clearInterval(this.botApiInterval);
    }
    if (this.noticeInterval) {
      clearInterval(this.noticeInterval);
    }
  },
  created() {
    this.loading = true;
    this.groupId = this.$route.query.groupId;

    this.noticeApi();
    this.botApi();
    if (this.$auth.user) {
      this.blackListApi();
    }
    this.thumbnailApi();
    // this.countConnect();
    this.loading = false;
    // this.$axios.get('/api/messages', {
    //   params: {
    //     room_id: this.groupId
    //   }
    // })
    //   .then(response => {
    //     this.chats = response.data.data

    //     this.timeProfile();
    //     this.loading = false
    //   })
    //   .catch(e => {
    //     console.log(e)
    //   })
    //  this.connect(this.groupId);
  },
};
